import { render, staticRenderFns } from "./ListaArquivos.vue?vue&type=template&id=5d222466&scoped=true"
import script from "./ListaArquivos.vue?vue&type=script&lang=js"
export * from "./ListaArquivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d222466",
  null
  
)

export default component.exports